"use client";
import React from "react";
import { Root, Portal, Overlay, Content, Title } from "@radix-ui/react-dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import styles from "./drawer.module.css";
function Drawer({
  children,
  onClose,
  open,
  title,
}: React.PropsWithChildren<{
  open: boolean;
  onClose: (open: boolean) => void;
  title?: React.ReactNode;
}>) {
  return (
    <Root open={open} onOpenChange={onClose}>
      <Portal>
        <Overlay className={styles.overlay} />
        <Content className={styles.content}>
          {title ? (
            <Title className={styles.title}>{title}</Title>
          ) : (
            <VisuallyHidden.Root>
              <Title>Drawer</Title>
            </VisuallyHidden.Root>
          )}
          {children}
        </Content>
      </Portal>
    </Root>
  );
}

export default Drawer;
